import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { IonToast } from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';
import { selectToastState } from './store/reducer';
import { toastActions } from './store/actions';
import { addIcons } from 'ionicons';
import { alertCircle, checkmarkCircle, close, warning } from 'ionicons/icons';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonToast, CommonModule],
})
export class ToastComponent {
  store = inject(Store);
  toast$ = this.store.select(selectToastState);

  toastButtons = [
    {
      icon: 'close',
      role: 'cancel',
    },
  ];

  constructor() {
    addIcons({ alertCircle, checkmarkCircle, close, warning });
  }

  onDidDismiss(): void {
    this.store.dispatch(toastActions.closeToast());
  }
}
